export default [
    {
        path: '/admin/notification/notification-histories',
        name: 'notification-history',
        meta: { requiresAuth: true },
        component: () => import('@/pages/notification/notification-history/index.vue')
    }
]
